import * as React from 'react';
import cx from 'classnames';
import * as styles from '../../styles/col.css';
export var Col = function Col(props) {
  var xs = props.xs,
      m = props.m,
      l = props.l,
      xsOffset = props.xsOffset,
      mOffset = props.mOffset,
      lOffset = props.lOffset,
      xsHidden = props.xsHidden,
      mHidden = props.mHidden,
      lHidden = props.lHidden,
      children = props.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(Boolean(xs) && [styles["col_xs_".concat(xs)]], Boolean(m) && [styles["col_m_".concat(m)]], Boolean(l) && [styles["col_l_".concat(l)]], Boolean(xsOffset) && [styles["col_xs_offset_".concat(xsOffset)]], Boolean(mOffset) && [styles["col_m_offset_".concat(mOffset)]], Boolean(lOffset) && [styles["col_l_offset_".concat(lOffset)]], Boolean(xsHidden) && [styles["col_xs_hidden"]], Boolean(mHidden) && [styles["col_m_hidden"]], Boolean(lHidden) && [styles["col_l_hidden"]])
  }, children);
};
Col.displayName = 'Col';